export default "__VITE_ASSET__DOMLOi4W__"